import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FooterComponent } from '../../landing-page-v2/components/footer/footer.component';
import { HeaderComponent } from '../../landing-page-v2/components/header/header.component';
import { DataCollectedComponent } from '../data-collected/data-collected.component';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: [
    '../../../assets/bootstrap/bootstrap.css',
    './privacy-policy.component.scss',
  ],
  standalone: true,
  imports: [
    HeaderComponent,
    DataCollectedComponent,
    FooterComponent,
    // Navbar1Component,
  ],
})
export class PrivacyPolicyComponent implements OnInit {
  constructor(private location: Location) {}

  ngOnInit(): void {}

  onClickGoBack() {
    this.location.back();
  }

  dashboardBaseURL: string = environment.dashboardURL;

  scrollToSection(sectionId: string) {
    const navbarToggler = document.getElementById('navbarToggler');
    const navbarNav = document.getElementById('navbarNav');
    if (navbarNav && navbarToggler) {
      if (navbarNav.classList.contains('show')) {
        navbarToggler.click();
      }
    }
  }

  onLoginClicked() {
    const navbarToggler = document.getElementById('navbarToggler');
    if (navbarToggler) navbarToggler.click();
    window.location.href = `${this.dashboardBaseURL}auth/login`;
  }
}
